import confetti from "./confetti.json";
const LOTTIE = {
  confetti,
};
export default LOTTIE;
